import React from 'react';
import PropTypes from 'prop-types';
import { showWhenPermission } from '@/shared/components/security';
import RegistrationsPerReport from './RegistrationsPerReport';

const RegistrationsPerResourceCategoryContainer = ({ searchParams }) => (
  <RegistrationsPerReport
    externalParams={searchParams}
    reportType={5}
    reportKey="RegsPerResourceCategoryReport"
  />
);
RegistrationsPerResourceCategoryContainer.propTypes = {
  searchParams: PropTypes.shape({}),
};

RegistrationsPerResourceCategoryContainer.defaultProps = {
  searchParams: {},
};
export default showWhenPermission(
  'RegistrationOwn',
  'read',
)(RegistrationsPerResourceCategoryContainer);
